import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { oneQuarter } from './helpers/helpers';
import { Text, Heading } from '../../../Elements';
import { textToDateDMY } from 'utils/common';

import classes from './DateRange.module.scss';

const DateRange = ({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  setSelectDate
}) => {
  const { t } = useTranslation(['activity']);

  const configListRange = [
    { name: t('activity:datepicker.TODAY'), id: 'today' },
    { name: t('activity:datepicker.LAST_7_DAYS'), id: 'days' },
    { name: t('activity:datepicker.ONE_MONTH'), id: 'month' },
    { name: t('activity:datepicker.THIS_QUARTER'), id: 'quarter' },
    { name: t('activity:datepicker.ONE_YEAR'), id: 'year' }
  ];

  const handleChoosePeriod = (e, modeText) => {
    let mode;
    if (e.currentTarget && e.currentTarget.id) {
      mode = e.currentTarget.id;
    } else {
      mode = e;
    }
    let startDate;
    let endDate;
    const periodDates = oneQuarter(new Date());
    switch (mode) {
      case 'today':
        startDate = moment();
        endDate = moment();
        if (modeText) {
          return {
            label: `${moment(startDate).format('DD/MM')} - ${moment(
              endDate
            ).format('DD/MM')}`,
            date: `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
              endDate
            ).format('DD/MM/YYYY')}`
          };
        } else {
          setStartDate(new Date(startDate));
          setEndDate(new Date(endDate));
          setSelectDate(new Date(startDate));
        }
        break;
      case 'days':
        startDate = moment().subtract(6, 'days');
        endDate = moment();
        if (modeText) {
          return {
            label: `${moment(startDate).format('DD/MM')} - ${moment(
              endDate
            ).format('DD/MM')}`,
            date: `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
              endDate
            ).format('DD/MM/YYYY')}`
          };
        } else {
          setStartDate(new Date(startDate));
          setEndDate(new Date(endDate));
          setSelectDate(new Date(startDate));
        }
        break;
      case 'month':
        startDate = moment().subtract(1, 'month');
        endDate = moment();
        if (modeText) {
          return {
            label: `${moment(startDate).format('DD/MM')} - ${moment(
              endDate
            ).format('DD/MM')}`,
            date: `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
              endDate
            ).format('DD/MM/YYYY')}`
          };
        } else {
          setStartDate(new Date(startDate));
          setEndDate(new Date(endDate));
          setSelectDate(new Date(startDate));
        }
        break;
      case 'quarter':
        if (modeText) {
          return {
            label: `${moment(periodDates.start, 'MM/DD/YYYY').format(
              'DD/MM'
            )} - ${moment(periodDates.end, 'MM/DD/YYYY').format('DD/MM')}`,
            date: `${moment(periodDates.start, 'MM/DD/YYYY').format(
              'DD/MM/YYYY'
            )} - ${moment(periodDates.end, 'MM/DD/YYYY').format('DD/MM/YYYY')}`
          };
        } else {
          setStartDate(new Date(periodDates.start));
          setEndDate(new Date(periodDates.end));
          setSelectDate(new Date(periodDates.start));
        }
        break;
      case 'year':
        startDate = moment().subtract(1, 'year');
        endDate = moment();
        if (modeText) {
          return {
            label: `${moment(startDate).format('MMM YY')} - ${moment(
              endDate
            ).format('MMM YY')}`,
            date: `${moment(startDate).format('DD/MM/YYYY')} - ${moment(
              endDate
            ).format('DD/MM/YYYY')}`
          };
        } else {
          setStartDate(new Date(startDate));
          setEndDate(new Date(endDate));
          setSelectDate(new Date(startDate));
        }
        break;
      default:
        return { label: '', date: '' };
    }
  };

  const isChecked = id => {
    const period = handleChoosePeriod(id, true);
    return period.date === textToDateDMY(startDate, endDate);
  };

  return (
    <section>
      <Heading className={classes.title}>
        {t('activity:datepicker.DATE_RANGE')}
      </Heading>
      <ul className={classes.dateRangeWrap}>
        {configListRange.map(item => (
          <li
            key={item.id}
            className={cn(
              classes.item,
              isChecked(item.id) && classes.item_isChecked
            )}
          >
            <div
              role="button"
              id={item.id}
              onClick={handleChoosePeriod}
              className={classes.item_button}
            >
              <Text>{item.name}</Text>
              <Text>{handleChoosePeriod(item.id, true).label}</Text>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

DateRange.propTypes = {
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  setSelectDate: PropTypes.func.isRequired
};

export default DateRange;
